import './App.css';
import { Routes, Route, NavLink, Navigate, useNavigate } from 'react-router-dom';
import Home from './components/Home'
import AdminDashboard from './components/AdminDashboard'
import UploadFSStudents from './components/UploadFSStudents';
import FSTeacherDashboard from "./components/FSTeacherDashboard"
import ManageFSStudents from './components/ManageFSStudents';
import ManageFSTeachers from './components/ManageFSTeachers'
import Monitoring from './components/Monitoring'
import { AiOutlineDashboard, AiOutlineHome, AiOutlineProject } from 'react-icons/ai';
import { IoMdLogOut } from 'react-icons/io'
import { MdGroup, MdGroups, MdOutlineUpload, MdOutlineDashboard } from "react-icons/md"
import { HiOutlineDocumentReport, HiUserGroup, HiUsers } from 'react-icons/hi';
import { BiEdit } from "react-icons/bi"
import { GiTeacher } from 'react-icons/gi'
import UploadFSTeachers from './components/UploadFSTeachers';
import KMIT from './Logos/KMIT logo1.gif'
import NGIT from './Logos/NGIT logo1.png'
import KMEC from './Logos/KMEC logo1.png'
import ForgotPassword from './components/ForgotPassword';
import { BsList } from "react-icons/bs"
import Test from './components/Test';
import PasswordChangeAdmin from './components/PasswordChangeAdmin';
import { IoSettingsOutline } from 'react-icons/io5';
import PageNotFound from './components/PageNotFound';
import CMonitoring from './components/CMonitoring'
import CAdminDashboard from './components/CAdminDashboard'
import Last7Days from './components/DashboardComponents/Last7Days';
import Daywise from './components/DashboardComponents/Daywise';
import OverallAtt from './components/DashboardComponents/OverallAtt';
import Deliquents from './components/DashboardComponents/Deliquents';
import CDaywise from './components/CAdminDashboardComponents/CDaywise'
import CLast7Sessions from './components/CAdminDashboardComponents/CLast7Sessions';
import COverallAtt from './components/CAdminDashboardComponents/COverallAtt';
import CDeliquents from './components/CAdminDashboardComponents/CDeliquents';
import CManageFSStudents from './components/CManageFSStudents'

function App() {
  const IP = "fs.kmitonline.com"
  //my mobile network
  // const IP = "192.168.77.9"
  //tele network
  // const IP = "172.20.36.26"
  //kmit college
  // const IP = "172.168.15.99"
  //access denied
  // const IP = "192.168.0.103"
  const navigate = useNavigate()
  let msg = sessionStorage.getItem("msg");
  let token = sessionStorage.getItem("token");
  let userObj = JSON.parse(sessionStorage.getItem("userObj"));

  const logout = () => {
    sessionStorage.clear()
    navigate("/")
  }

  return (
    <div className='App'>
      <div className='content'>
        {
          msg == null ?
            <div div className='header-bg mb-2'>
              <div className='inner-header container'>
                <h2 className='title mt-2'>The Finishing School</h2>
                <div className='logo-container'>
                  <img src={KMIT} alt='KMIT LOGO' className="header-logo kmit-logo" />
                  <img src={NGIT} alt='NGIT LOGO' className="header-logo ngit-logo" />
                  {/* <img src={KMEC} alt='KMEC LOGO' className="header-logo kmec-logo" /> */}
                </div>
              </div>
            </div>
            :
            <>
              {msg == "Teacher%%Login%%Success?mentorLoggedIn!!@#$" && window.location.href != `http://${IP}` &&
                <nav className="navbar navbar-expand-lg sticky-top">
                  <div className="container-fluid">
                    <h2 className="navbar-brand mt-2 text-white">The Finishing School</h2>
                    <button className="navbar-toggler text-white" type="button" data-bs-toggle="collapse" data-bs-target="#TeacherUI" aria-controls="TeacherUI" aria-expanded="false" aria-label="Toggle navigation">
                      <span className="mt-1"><BsList className='mb-1 text-white' /></span>
                    </button>
                    <div className="collapse navbar-collapse" id="TeacherUI">
                      <ul className="navbar-nav ms-auto mb-2 mb-lg-0 mb-md-0">
                        <li className="nav-item">
                          <a className="nav-link" onClick={logout}><IoMdLogOut className='mb-1' /> Logout ({userObj.name.toUpperCase()})</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </nav>
              }
              {(msg == "Admin%%Login%%Success?adminLoggedIn@#$%$@" && userObj.role === 'admin') && window.location.href != `http://${IP}` &&
                <nav className="navbar navbar-expand-lg sticky-top">
                  <div className="container-fluid">
                    <h2 className="navbar-brand mt-2 text-white">The Finishing School</h2>
                    <button className="navbar-toggler text-white" type="button" data-bs-toggle="collapse" data-bs-target="#AdminUI" aria-controls="AdminUI" aria-expanded="false" aria-label="Toggle navigation">
                      <span className="mt-1"><BsList className='mb-1 text-white' /></span>
                    </button>
                    <div className="collapse navbar-collapse" id="AdminUI">
                      <ul className="navbar-nav me-auto mb-2 mb-lg-0 mb-md-0">
                        <li className="nav-item">
                          <NavLink className="nav-link" to='admin/dashboard'><MdOutlineDashboard className='mb-1' /> Dashboard</NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink className="nav-link" to='admin/monitoring'><AiOutlineDashboard className='mb-1' /> Monitoring</NavLink>
                        </li>
                        <li className="nav-item dropdown">
                          <span data-bs-toggle="dropdown" aria-expanded="false" className="nav-link dropdown-toggle"><MdOutlineUpload className="mb-1" /> Upload</span>
                          <ul className="dropdown-menu dropdown-menu-light m-0 p-0">
                            {/* <li className="nav-item">
                              <NavLink className="nav-link dropdown-item dd" to='upload/fs-batch'><MdGroups className="mb-1" /> FS Batch</NavLink>
                            </li> */}
                            <li className="nav-item">
                              <NavLink className="nav-link dropdown-item dd" to='upload/fs-students'><HiUsers className="mb-1" /> FS Students</NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink className="nav-link dropdown-item dd" to='upload/fs-teachers'><GiTeacher className="mb-1" /> FS Teachers</NavLink>
                            </li>
                          </ul>
                        </li>

                        <li className="nav-item dropdown">
                          <span data-bs-toggle="dropdown" aria-expanded="false" className="nav-link dropdown-toggle"><BiEdit className="mb-1" /> Manage</span>
                          <ul className="dropdown-menu dropdown-menu-light m-0 p-0">
                            <li className="nav-item">
                              <NavLink className="nav-link dropdown-item dd" to='manage/fs-students'><HiUsers className="mb-1" /> FS Students</NavLink>
                            </li>
                            {/* <li className="nav-item">
                              <NavLink className="nav-link dropdown-item dd" to='manage/projects-list'><MdGroups className="mb-1" /> FS Sections</NavLink>
                            </li> */}
                            <li className="nav-item">
                              <NavLink className="nav-link dropdown-item dd" to='manage/fs-teachers'><GiTeacher className="mb-1" /> FS Teachers</NavLink>
                            </li>
                          </ul>
                        </li>


                        {/* <li className="nav-item">
                          <NavLink className="nav-link" to='attendance'><HiOutlineDocumentReport className="mb-1" /> Attendance</NavLink>
                        </li> */}
                      </ul>
                      <ul className="navbar-nav ms-auto mb-2 mb-lg-0 mb-md-0">
                        <li className="nav-item">
                          <NavLink className="nav-link" to='admin/change-password'><IoSettingsOutline className='mb-1' /> Change Password</NavLink>
                        </li>
                        <li className="nav-item">
                          <a className="nav-link" onClick={logout}><IoMdLogOut className='mb-1' /> Logout ({userObj.name.toUpperCase()})</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </nav>
              }
              {msg == "College%%Admin%%Login%%Success?CollegeadminLoggedIn$#@!$%" && window.location.href != `http://${IP}` &&
                <nav className="navbar navbar-expand-lg sticky-top">
                  <div className="container-fluid">
                    <h2 className="navbar-brand mt-2 text-white">The Finishing School</h2>
                    <button className="navbar-toggler text-white" type="button" data-bs-toggle="collapse" data-bs-target="#CAdminUI" aria-controls="CAdminUI" aria-expanded="false" aria-label="Toggle navigation">
                      <span className="mt-1"><BsList className='mb-1 text-white' /></span>
                    </button>
                    <div className="collapse navbar-collapse" id="CAdminUI">
                      <ul className="navbar-nav me-auto mb-2 mb-lg-0 mb-md-0">
                        <li className="nav-item">
                          <NavLink className="nav-link" to='cadmin/dashboard'><MdOutlineDashboard className='mb-1' /> Dashboard</NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink className="nav-link" to='cadmin/monitoring'><AiOutlineDashboard className='mb-1' /> Monitoring</NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink className="nav-link" to='cadmin/manage-fs-students'><HiUsers className='mb-1' /> Manage Students</NavLink>
                        </li>
                      </ul>
                      <ul className="navbar-nav ms-auto mb-2 mb-lg-0 mb-md-0">
                        <li className="nav-item">
                          <NavLink className="nav-link" to='cadmin/change-password'><IoSettingsOutline className='mb-1' /> Change Password</NavLink>
                        </li>
                        <li className="nav-item">
                          <a className="nav-link" onClick={logout}><IoMdLogOut className='mb-1' /> Logout ({userObj.name.toUpperCase()})</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </nav>
              }

            </>
        }

        <Routes>
          <Route path="*" element={<PageNotFound />} />
          {/* <Route path="/test" element={<Test IP={IP} />} /> */}
          <Route path="/" element={userObj == null ? <Home IP={IP} /> : <>{msg == "Admin%%Login%%Success?adminLoggedIn@#$%$@" && <Navigate replace to="/admin/dashboard" />}{msg == "Student Login Success" && <Navigate replace to="/student/dashboard" />}</>} />
          <Route path="/forgot-password" element={userObj == null ? <ForgotPassword IP={IP} /> : <>{msg == "Admin%%Login%%Success?adminLoggedIn@#$%$@" ? <Navigate replace to="/admin/dashboard" /> : <Navigate replace to="/student/dashboard" />}</>} />

          <Route>
            <Route path="/admin/dashboard/*" element={(msg == "Admin%%Login%%Success?adminLoggedIn@#$%$@" && userObj.role == 'admin') ? <AdminDashboard IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} >
              <Route path="day-wise" element={(msg == "Admin%%Login%%Success?adminLoggedIn@#$%$@" && userObj.role == 'admin') ? <Daywise IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
              <Route path="" element={<Navigate replace to="day-wise" />} />
              <Route path="last-7-sessions" element={(msg == "Admin%%Login%%Success?adminLoggedIn@#$%$@" && userObj.role == 'admin') ? <Last7Days IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
              <Route path="overall-attendance" element={(msg == "Admin%%Login%%Success?adminLoggedIn@#$%$@" && userObj.role == 'admin') ? <OverallAtt IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
              <Route path="deliquents" element={(msg == "Admin%%Login%%Success?adminLoggedIn@#$%$@" && userObj.role == 'admin') ? <Deliquents IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
            </Route>
            <Route path='' element={<Navigate replace to="/admin/dashboard" />} />
            <Route path="/admin/monitoring" element={(msg == "Admin%%Login%%Success?adminLoggedIn@#$%$@" && userObj.role == 'admin') ? <Monitoring IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
            <Route path='upload/fs-students' element={(msg == "Admin%%Login%%Success?adminLoggedIn@#$%$@" && userObj.role == 'admin') ? <UploadFSStudents IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
            <Route path='upload/fs-teachers' element={(msg == "Admin%%Login%%Success?adminLoggedIn@#$%$@" && userObj.role == 'admin') ? <UploadFSTeachers IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
            <Route path='manage/fs-students' element={(msg == "Admin%%Login%%Success?adminLoggedIn@#$%$@" && userObj.role == 'admin') ? <ManageFSStudents IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
            <Route path='manage/fs-teachers' element={(msg == "Admin%%Login%%Success?adminLoggedIn@#$%$@" && userObj.role == 'admin') ? <ManageFSTeachers IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
            <Route path='/admin/change-password' element={(msg == "Admin%%Login%%Success?adminLoggedIn@#$%$@" && userObj.role == 'admin') ? <PasswordChangeAdmin IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
          </Route>

          <Route>
            <Route path="/cadmin/dashboard/*" element={msg == "College%%Admin%%Login%%Success?CollegeadminLoggedIn$#@!$%" ? <CAdminDashboard IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} >
              <Route path="c-day-wise" element={msg == "College%%Admin%%Login%%Success?CollegeadminLoggedIn$#@!$%" ? <CDaywise IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
              <Route path="" element={<Navigate replace to="c-day-wise" />} />
              <Route path="c-last-7-sessions" element={msg == "College%%Admin%%Login%%Success?CollegeadminLoggedIn$#@!$%" ? <CLast7Sessions IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
              <Route path="c-overall-attendance" element={msg == "College%%Admin%%Login%%Success?CollegeadminLoggedIn$#@!$%" ? <COverallAtt IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
              <Route path="c-deliquents" element={msg == "College%%Admin%%Login%%Success?CollegeadminLoggedIn$#@!$%" ? <CDeliquents IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
            </Route>
            <Route path='' element={<Navigate replace to="cadmin/dashboard" />} />
            <Route path="cadmin/monitoring" element={msg == "College%%Admin%%Login%%Success?CollegeadminLoggedIn$#@!$%" ? <CMonitoring IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
            <Route path="cadmin/manage-fs-students" element={msg == "College%%Admin%%Login%%Success?CollegeadminLoggedIn$#@!$%" ? <CManageFSStudents IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
            <Route path='cadmin/change-password' element={msg == "College%%Admin%%Login%%Success?CollegeadminLoggedIn$#@!$%" ? <PasswordChangeAdmin IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
          </Route>

          <Route>
            <Route path="/fs-teacher/dashboard/*" element={msg == "Teacher%%Login%%Success?mentorLoggedIn!!@#$" ? <FSTeacherDashboard IP={IP} TOKEN={token} UserObj={userObj} /> : <Navigate replace to="/" />} />
            {/* <Route path='' element={<Navigate replace to="/fs-teacher/dashboard" />} /> */}
          </Route>

        </Routes>
      </div >

      <footer className='footer'>
        <p className='p-0 m-0 text-center'>Copyright &copy; {(new Date().getFullYear())} Teleparadigm Networks Pvt. Ltd. All Rights Reserved.</p>
      </footer>
    </div >
  );
}

export default App;
